export default {
	methods: {
		clone (element) {
			return JSON.parse(JSON.stringify(element))
		}
	}
}
